module.exports = "<h3>Sorry! Looks like page you are looking for not avaialble!</h3>\n\n<p>Let's go <a routerLink=\"/login\">Home</a>!</p>"